// import { useConfigStore } from '../'
import { useRuntimeConfig} from "nuxt/app";

export default defineNuxtPlugin(() => {
    return {
        provide: {
            getAppInfo: () => {
                const nuxtApp = useNuxtApp()
                const config = nuxtApp.vueApp.$nuxt.$pinia.state._value.config?.currentConfig

                // const config = useConfigStore()
                return config.app_info
            },
        },
    }
})
